import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "comments" }

import { ShortComments, CollaborationList } from "../../components/comments";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_spacer, {
      class: _normalizeClass({ 'py-6': _unref(xs), 'py-10': _unref(smAndUp) })
    }, null, 8, ["class"]),
    _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
      default: _withCtx(() => [
        _createVNode(_unref(ShortComments))
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, {
      class: _normalizeClass({ 'py-5': _unref(xs), 'py-8': _unref(smAndUp) })
    }, null, 8, ["class"]),
    _createVNode(_unref(CollaborationList))
  ]))
}
}

})